'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Link_module = require('../styles/Link.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Link component is used for anchor links. This component renders a a element by default
 *
 * @component
 * @example
 * ```jsx
 * <Link href="#">Link</Link>
 * ```
 */
const Link = React__namespace.forwardRef((props, ref) => {
    const { color, strong, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Link_module.default);
    const classNames = cx(className, 'container', {
        [`color-${color}`]: color,
        strong,
    });
    return (React__namespace.createElement("a", { ref: ref, className: classNames, ...restProps }, children));
});
Link.defaultProps = {
    color: 'blue',
};
Link.displayName = 'Link';

exports.Link = Link;
//# sourceMappingURL=Link.js.map
